import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

const sigProjectsData = [
  {
    title: 'Estudio de Movilidad Sustentable Comuna de La Unión',
    name: 'Análisis y Desarrollo del Estudio de Movilidad Sustentable de la Comuna de La Unión',
    owner: '',
    consultant: 'Movilidad, Sustentabilidad, Transporte y Diseño Vial, MSTD, Limitada.',
    mosaicDate: '12 y 13 de septiembre 2024',
    mosaicRes: '',
    area: '',
    layers: ['Área', 'Construcciones', 'Equipamiento', 'Predios', 'Red Hidrológica', 'Servicios', 'Topografía', 'Varios', 'Vegetación', 'Vialidad']
  },
  {
    title: 'Estudio de Movilidad Sustentable Comuna de Santa Juana',
    name: 'Análisis y Desarrollo del Estudio de Movilidad Sustentable de la Comuna de Santa Juana',
    owner: 'Programa de Vialidad y Transporte Urbano, SECTRA SUR',
    consultant: 'Movilidad, Sustentabilidad, Transporte y Diseño Vial, MSTD, Limitada.',
    mosaicDate: '13 de diciembre de 2023',
    mosaicRes: '5 cm de pixel',
    area: '520 hectáreas',
    layers: ['Puntos de control', 'Construcciones', 'Equipamiento', 'Predio', 'Red Hidrológica', 'Servicios', 'Topografía', 'Varios', 'Vegetación', 'Vialidad']
  },
  {
    title: 'Estudio de Movilidad Sustentable Comuna de San Carlos',
    name: 'Análisis y Desarrollo del Estudio de Movilidad Sustentable de la Comuna de San Carlos',
    owner: '',
    consultant: '',
    mosaicDate: '',
    mosaicRes: '',
    area: '',
    layers: ['Área', 'Construcciones', 'Equipamiento', 'Predios', 'Red Hidrológica', 'Servicios', 'Topografía', 'Varios', 'Vegetación', 'Vialidad']
  },
]

const dataCols = [
  { title: 'Nombre estudio:', key: 'name' },
  { title: 'Mandante:', key: 'owner' },
  { title: 'Consultora:', key: 'consultant' },
  { title: 'Fecha de imágenes:', key: 'mosaicDate' },
  { title: 'Tamaño Resolución:', key: 'mosaicRes' },
  { title: 'Área Estudio:', key: 'area' },
  { title: 'Capas:', key: 'layers' },
]

const MapInfo = ({ isOpen, projectCode, dataPosToUse, closeModal }) => {
  return (
    <Modal show={isOpen} onHide={() => closeModal()} scrollable>
      <Modal.Header closeButton>
        <Modal.Title>{ 'Información Proyecto - ' + ((dataPosToUse > -1) ? sigProjectsData[dataPosToUse].title : projectCode )}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="d-flex flex-column">
        {projectCode && (dataPosToUse > -1) ? 
          <div>
            {dataCols.map((item, itemIdx) => 
              sigProjectsData[dataPosToUse][item.key] ? 
                <div key={itemIdx} className="my-2">
                  <span className="fw-bold">{item.title}</span>
                  <span> {item.key === 'layers' ? sigProjectsData[dataPosToUse][item.key].join(', ') : sigProjectsData[dataPosToUse][item.key]} </span>
                </div>
              : null 
            )}
          </div>
        : null }
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => closeModal()}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default MapInfo
